import { c as _c } from "react/compiler-runtime";
type LogoProps = React.SVGAttributes<SVGElement>;
export function Logo(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M0 0V625C0 652.614 22.3858 675 50 675H150C177.614 675 200 652.614 200 625V200H350C377.614 200 400 222.386 400 250V625C400 652.614 422.386 675 450 675H550C577.614 675 600 652.614 600 625V200C600 89.5431 510.457 0 400 0H0Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 715" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}